import { ApiCall } from 'omni-common-ui';
import { fetch, buildUrl } from 'domain/Api';
import { actions as personalisedHomework } from 'data/OnlineHomework/Personalised';

export const FETCH_HOMEWORK_REQUEST = 'FETCH_HOMEWORK_REQUEST';
export const FETCH_HOMEWORK_SUCCESS = 'FETCH_HOMEWORK_SUCCESS';
export const FETCH_HOMEWORK_FAILURE = 'FETCH_HOMEWORK_FAILURE';
export const PUBLISH_HOMEWORK_REQUEST = 'PUBLISH_HOMEWORK_REQUEST';
export const PUBLISH_HOMEWORK_SUCCESS = 'PUBLISH_HOMEWORK_SUCCESS';
export const PUBLISH_HOMEWORK_FAILURE = 'PUBLISH_HOMEWORK_FAILURE';
export const CLEAR_HOMEWORK_REQUEST = 'CLEAR_HOMEWORK_REQUEST';
export const CLEAR_HOMEWORK_SUCCESS = 'CLEAR_HOMEWORK_SUCCESS';
export const CLEAR_HOMEWORK_FAILURE = 'CLEAR_HOMEWORK_FAILURE';

const buildGetHomeworkUrl = (sessionId) => buildUrl(`/sessions/${sessionId}/homework`);
const buildPublishHomeworkUrl = (sessionId) => buildUrl(`/sessions/${sessionId}/homework-publish`);
const buildClearHomeworkUrl = (sessionId) => buildUrl(`/sessions/${sessionId}/student-homework-clear`);

export function fetchHomeworkIfNeeded(sessionId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildGetHomeworkUrl(sessionId) })) {
      return false;
    }

    return dispatch(fetchHomework(sessionId));
  };
}

export function fetchHomework(sessionId) {
  return (dispatch) => {
    const url = buildGetHomeworkUrl(sessionId);
    const method = 'GET';

    return dispatch(fetchHomeworkRequest()).payload
      .then((response) => dispatch(fetchHomeworkSuccess(response)))
      .then((response) => {
        response.payload.personalisedHomework &&
        response.payload.personalisedHomework.forEach(
          (ph) => dispatch(personalisedHomework.fetchPersonalisedHomeworkIfNeeded(ph.id, ph.status))
        );
      })
      .catch((error) => dispatch(fetchHomeworkFailure(error)));

    function fetchHomeworkRequest() {
      return ApiCall.createAction({
        type: FETCH_HOMEWORK_REQUEST,
        payload: fetch(url),
        url,
        method,
        sessionId,
      });
    }

    function fetchHomeworkSuccess(homework) {
      return ApiCall.createAction({
        type: FETCH_HOMEWORK_SUCCESS,
        payload: homework,
        url,
        method,
        sessionId,
      });
    }

    function fetchHomeworkFailure(error) {
      return ApiCall.createAction({
        type: FETCH_HOMEWORK_FAILURE,
        error,
        url,
        method,
        sessionId,
      });
    }
  };
}

export function publishHomework(sessionId) {
  return (dispatch) => {
    const url = buildPublishHomeworkUrl(sessionId);
    const method = 'PUT';  // why PUT?
    const request = fetch(url, { method });

    return dispatch(fetchPersonalisedHomeworkRequest()).payload
      .then((response) => dispatch(fetchPersonalisedHomeworkSuccess(response)))
      .catch((error) => dispatch(fetchPersonalisedHomeworkFailure(error)));

    function fetchPersonalisedHomeworkRequest() {
      return ApiCall.createAction({
        type: PUBLISH_HOMEWORK_REQUEST,
        payload: request,
        url,
        method,
        sessionId,
      });
    }

    function fetchPersonalisedHomeworkSuccess() {
      return ApiCall.createAction({
        type: PUBLISH_HOMEWORK_SUCCESS,
        url,
        method,
        sessionId,
      });
    }

    function fetchPersonalisedHomeworkFailure(error) {
      return ApiCall.createAction({
        type: PUBLISH_HOMEWORK_FAILURE,
        error,
        url,
        method,
        sessionId,
      });
    }
  };
}

export function clearHomework(sessionId) {
  return (dispatch) => {
    const url = buildClearHomeworkUrl(sessionId);
    const method = 'DELETE';
    const request = fetch(url, { method });

    return dispatch(clearHomeworkRequest()).payload
      .then((response) => dispatch(clearHomeworkSuccess(response)))
      .catch((error) => dispatch(clearHomeworkFailure(error)));

    function clearHomeworkRequest() {
      return ApiCall.createAction({
        type: CLEAR_HOMEWORK_REQUEST,
        payload: request,
        url,
        method,
        sessionId,
      });
    }

    function clearHomeworkSuccess() {
      return ApiCall.createAction({
        type: CLEAR_HOMEWORK_SUCCESS,
        url,
        method,
        sessionId,
      });
    }

    function clearHomeworkFailure(error) {
      return ApiCall.createAction({
        type: CLEAR_HOMEWORK_FAILURE,
        error,
        url,
        method,
        sessionId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/Homework/actions.js